import React, { useState } from 'react';
import { postDeceasedCondolences } from '../api/deceased_req';
import '../style/CondolenceModal.css';

export default function CondolenceModal({ deceased, onClose, onSuccess }) {
    const [formData, setFormData] = useState({
        civility: '',
        last_name: '',
        first_name: '',
        email: '',
        country: 'France',
        zipcode: '',
        city: '',
        message: '',
        address: '',
        phone: '',
        public: false,
        info: false
    });
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState('');

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!formData.last_name || !formData.first_name || !formData.message) {
            setError('Le nom, le prénom et le message sont obligatoires');
            return;
        }

        setSubmitting(true);
        try {
            const dataToSend = {
                ...formData,
                deceased_id: deceased.id
            };
            await postDeceasedCondolences(dataToSend);
            onSuccess();
            onClose();
        } catch (err) {
            console.error('Error posting condolence:', err);
            setError('Erreur lors de l\'envoi de votre message. Veuillez réessayer.');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="modal-close" onClick={onClose}>×</button>

                <h2>Déposer vos condoléances</h2>
                <p className="modal-subtitle">
                    Pour {deceased.full_name_long || `${deceased.first_name} ${deceased.last_name}`}
                </p>

                <form onSubmit={handleSubmit}>
                    <div className="form-row">
                        <div className="form-group">
                            <label htmlFor="civility">Civilité</label>
                            <select
                                id="civility"
                                name="civility"
                                value={formData.civility}
                                onChange={handleChange}
                            >
                                <option value="">Sélectionner</option>
                                <option value="M.">Monsieur</option>
                                <option value="Mme">Madame</option>
                            </select>
                        </div>

                        <div className="form-group">
                            <label htmlFor="last_name">Nom *</label>
                            <input
                                type="text"
                                id="name"
                                name="last_name"
                                value={formData.last_name}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="first_name">Prénom *</label>
                            <input
                                type="text"
                                id="firstname"
                                name="first_name"
                                value={formData.first_name}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="form-group">
                            <label htmlFor="email">Email</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="country">Pays *</label>
                            <select
                                id="country"
                                name="country"
                                value={formData.country}
                                onChange={handleChange}
                                required
                            >
                                <option value="France">France</option>
                                <option value="Belgique">Belgique</option>
                                <option value="Suisse">Suisse</option>
                                <option value="Canada">Canada</option>
                                <option value="Autre">Autre</option>
                            </select>
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="form-group form-group-small">
                            <label htmlFor="zipcode">Code Postal *</label>
                            <input
                                type="text"
                                id="postal_code"
                                name="zipcode"
                                value={formData.zipcode}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="form-group form-group-large">
                            <label htmlFor="city">Ville *</label>
                            <input
                                type="text"
                                id="city"
                                name="city"
                                value={formData.city}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <label htmlFor="message">
                            Votre message *
                            <span className="label-note">(sera réservé de validation par le modérateur)</span>
                        </label>
                        <textarea
                            id="message"
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                            required
                            rows="6"
                        />
                    </div>

                    <div className="form-row">
                        <div className="form-group">
                            <label htmlFor="address">Adresse Postale</label>
                            <input
                                type="text"
                                id="postal_address"
                                name="address"
                                value={formData.address}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="phone">Téléphone</label>
                            <input
                                type="tel"
                                id="phone"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className="form-checkboxes">
                        <label className="checkbox-label">
                            <input
                                type="checkbox"
                                name="public"
                                checked={formData.public}
                                onChange={handleChange}
                            />
                            <span>
                                Je souhaite que mon message soit publié dans l'espace condoléances du défunt
                            </span>
                        </label>

                        <label className="checkbox-label">
                            <input
                                type="checkbox"
                                name="info"
                                checked={formData.info}
                                onChange={handleChange}
                            />
                            <span>
                                Souhaite être averti d'événements futurs concernant ce défunt (anniversaire, commémoration, ...) ou autres éléments d'information
                            </span>
                        </label>
                    </div>

                    {error && <p className="error-message">{error}</p>}

                    <div className="form-actions">
                        <button type="submit" disabled={submitting} className="btn-submit">
                            {submitting ? 'Envoi...' : 'Envoyer'}
                        </button>
                        <button type="button" onClick={onClose} className="btn-cancel">
                            Retour avis de décès
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
